import { Injectable } from '@angular/core';

declare var amplitude: any;

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  constructor() { }

  setUserProperties(user: any): void {
    amplitude.getInstance().setUserProperties(user);
  }

  logEvent(key: string, object?: any): void {
    if (object) {
      amplitude.getInstance().logEvent(key);
    } else {
      amplitude.getInstance().logEvent(key, object);
    }
  }
}
